import ButtonStyleSelect from "@/components/ButtonStyleSelect";

/**
 * Pant Front Button row — displays the factory parent code (T-3454, "Customer
 * appointed button") as a fixed badge and exposes a searchable button-catalog
 * dropdown. Picked button code is stored under `pant_front_button_code` so it
 * doesn't collide with the qualitative `pant_front_button` field selected via
 * the auto-style "More Style Details" panel.
 */
export default function PantFrontButtonRow({ pantStyling, setPantStyling, testId }) {
  return (
    <div className="mt-3 pt-3 border-t border-white/5" data-testid={testId}>
      <div className="flex items-center gap-2 mb-2">
        <p className="text-[10px] uppercase tracking-wider text-slate-400">
          Front Button
        </p>
        <code className="text-[10px] text-amber-400/80 font-mono">T-3454</code>
        <span className="text-[10px] text-slate-500 italic">
          (Customer appointed button)
        </span>
      </div>
      <div className="max-w-sm">
        <ButtonStyleSelect
          label=""
          category="suit"
          value={pantStyling?.pant_front_button_code}
          onChange={(v) =>
            setPantStyling({ ...pantStyling, pant_front_button_code: v })
          }
          testId={`${testId}-select`}
        />
      </div>
    </div>
  );
}
